import { App } from '@capacitor/app';
import { esApp } from './plataforma';

/** La pantalla de «actualiza la app» o su logo de espera (`ActualizacionObligatoria`). */
const ACTUALIZACION_OBLIGATORIA = '[data-actualizacion-obligatoria]';

/**
 * Cualquier diálogo, hoja o cajón de Radix (y de vaul) que esté abierto. Un diálogo con `open`
 * fijo y sin `onOpenChange` no se cierra con Escape solo: necesita `onEscapeKeyDown` (ver
 * `OfertaBiometria` e `InterruptorBiometria`).
 */
const DIALOGO_ABIERTO =
	'[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]';

/**
 * El botón atrás de Android, dentro de la app.
 *
 * Sin esto, Capacitor cierra la app al pulsarlo desde cualquier pantalla. Por orden:
 *
 * 0. Con «actualiza la app» delante, la cierra: no hay nada a lo que volver.
 * 1. Con un diálogo abierto, lo cierra —es lo que espera cualquiera en Android—. Se hace mandando
 *    «Escape», que es como los diálogos ya se cierran con teclado: no hay que tocarlos uno a uno.
 * 2. Con historial, vuelve a la pantalla anterior, como en el navegador.
 * 3. Sin historial, sale de la app.
 *
 * En la web no hace nada.
 */
export const registrarBotonAtras = (): void => {
	if (!esApp()) {
		return;
	}

	void App.addListener('backButton', ({ canGoBack }) => {
		if (document.querySelector(ACTUALIZACION_OBLIGATORIA)) {
			void App.exitApp();
			return;
		}

		if (document.querySelector(DIALOGO_ABIERTO)) {
			document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
			return;
		}

		if (canGoBack) {
			window.history.back();
		} else {
			void App.exitApp();
		}
	});
};
